import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {Theme} from '../contexts/theme';
import {getMatchDate} from '../utils/formatting';

import styles from './match.module.css';

const MAX_LENGTH_TEAM = 18;

export default function Match({date, localTeam, visitorTeam, className, isHorizontal = false}) {
  const {i18n: {language}} = useTranslation();
  const theme = useContext(Theme);
  const blockMatchTimeClasses = clsx({
    [styles.blockMatchTime]: true,
    [styles.blockMatchTimePrimary]: !isHorizontal,
    [styles.blockMatchTimeSecondary]: isHorizontal
  });
  const blockTeamsClasses = clsx({
    [styles.blockTeams]: true,
    [styles.blockTeamsPrimary]: !isHorizontal,
    [styles.blockTeamsSecondary]: isHorizontal,
    [styles.blockTeamsLocalWinner]: +localTeam.score > +visitorTeam.score,
    [styles.blockTeamsVisitorWinner]: +visitorTeam.score > +localTeam.score
  });
  const teamScoreClasses = clsx({
    [styles.teamScore]: true,
    [styles.bottomIndent]: visitorTeam.name?.length < MAX_LENGTH_TEAM
  });

  return (
    <div className={clsx({[className]: className, [styles.blockMatch]: true, [styles[`blockMatch${theme}`]]: true})}>
      {date
        ? <time dateTime={date} className={blockMatchTimeClasses}>{getMatchDate(date, language)}</time>
        : <span className={blockMatchTimeClasses}>—</span>
      }
      <div className={blockTeamsClasses}>
        <div className={clsx(styles.team, styles.borderDashed)}>
          <p className={clsx(styles.teamName, styles.bottomIndent)}>
            {localTeam.name || '—'}
          </p>
          <p className={styles.teamScore}>{localTeam.score || 0}</p>
        </div>
        <div className={clsx(styles.team, styles.visitorTeam)}>
          <p className={teamScoreClasses}>
            {visitorTeam.score || 0}
          </p>
          <p className={styles.teamName}>{visitorTeam.name || '—'}</p>
        </div>
      </div>
    </div>
  );
}
